import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'
import './index.css'
import './styles/doctors-agent.css'
import './styles/editorial.css'

// v7_partialHydration: required for react-router's data router to hydrate
// correctly against prerendered HTML when routes use `lazy`, without it the
// router starts client-side hydration in a transient loading state that
// doesn't match the server output, which React reports as a hydration
// mismatch (error #418/#423) and recovers from by discarding the whole
// prerendered tree and re-rendering everything client-side from scratch.
export const createRoot = ViteReactSSG({
  routes,
  future: { v7_partialHydration: false },
}, undefined, {
  // React 18.3 compatibility: reuse the prerendered DOM instead of appending a second tree.
  useLegacyRender: true,
})
